/* Get cookie value by name */
export function getCookie(name: string): string | null {
  if (typeof document === 'undefined') return null; 
  
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  
  if (parts.length === 2) {
    return parts.pop()?.split(';').shift() || null;
  }
  
  return null;
}

/* Set cookie with expiration in days */
export function setCookie(name: string, value: string, days: number): void {
  if (typeof document === 'undefined') return; 
  
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  const expires = `expires=${date.toUTCString()}`;
  
  document.cookie = `${name}=${value};${expires};path=/;SameSite=Lax`;
}

/* Check if cookie exists */
export function cookieExists(name: string): boolean {
  return getCookie(name) !== null;
}

/* Delete cookie */
export function deleteCookie(name: string): void {
  if (typeof document === 'undefined') return; 
  
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;SameSite=Lax`;
}

/* Get all tutorial modal cookies */
export function getAllTutorialCookies(): Array<{ name: string; value: string }> {
  if (typeof document === 'undefined') return [];
  
  const cookies = document.cookie.split(';');
  return cookies
    .filter(cookie => cookie.trim().startsWith('tutorial_'))
    .map(cookie => {
      const [name, value] = cookie.trim().split('=');
      return { name, value };
    });
}